/* eslint-disable no-unused-vars */
export default async (context, inject) => {
  inject('page', {
    
    set title(value) {
      document.title = value
    },
    
    get queryParams() {
      return ''
    },

    set queryParams(data) {
      context.store.commit('page/set', data)
    },

    set confirmReload(value) {
      context.store.dispatch('CONFIRM_RELOAD', value)
    },

    get confirmReload() {
      return ''
    },

    errorHandler(error, options = {navigate: false, toasted: false}) {
      if (options.toasted) {
        // open toasted
      }

      if (options.navigate) {
        switch(error?.status) {
        case 403:
          // unauthorized
          context.router.push('/pages/no-valid-plan-menu')
          break
        case 404:
          // not found
          context.router.push('/pages/not-found')
          break
        case 500:
          context.router.push('/pages/internal-error')
          break
        }
      }
    }
  })
}
